define.alias("shared/utils/remove-html-literals", "settings/utils/remove-html-literals");